<template>
  <div class="clients">

    <div class="clients__title">
      Bordereaux de Commissions
    </div>

    <div class="clients__subtitle">
        Recherche de Bordereaux de Commissions
    </div>

    <CommissionsCustomFilter
        :filters="filters"
    />

    <template v-if="isBusy">
      <Preloader />
    </template>

    <template v-else>
      <template v-if="commissions.data.length > 0">
        <div class="clients__table">
          <div class="clients__table__item">
            <div class="clients__table__item--cell">Date</div>
            <div class="clients__table__item--cell small_wider">N° de Bordereau</div>
            <div class="clients__table__item--cell">Montant</div>
            <div class="clients__table__item--cell icon-cell">Bordereau</div>
          </div>

          <div class="clients__table__item" v-for='commission in commissions.data'>
            <div class="clients__table__item--cell">{{parseDate(commission.created_at)}}</div>
            <div class="clients__table__item--cell small_wider">{{commission.commission_number}}</div>
            <div class="clients__table__item--cell">{{parseFloat(commission.amount).toFixed(2)}} €</div>
            <div class="clients__table__item--cell icon-cell">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_pdf(commission.id)"/>
            </div>
          </div>
        </div>

        <pagination :data="commissions" @pagination-change-page="getCommissions" />
      </template>

      <template v-else>
        <div class="subscribes-empty">Il n'y a aucun bordereau de commission à ce jour.</div>
      </template>
    </template>

    <template v-else>
        <Preloader/>
    </template>
  </div>
</template>

<script>
    import Preloader from '@/components/Preloader';
    import CommissionsCustomFilter from '@/components/Commissions/CommissionsCustomFilter'

    export default {
        name: 'Commissions',
        components: {Preloader, CommissionsCustomFilter},
        data() {
            return {
                isBusy: false,
                commissions: {
                    data: []
                },
                filters: {
                    start_date: null,
                    end_date: null,
                    amount: ''
                },
            }
        },
        computed: {
          mechanic_id() {
            return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
          },
        },
        methods: {
            isMutuaide() {
              return this.$store.getters.isMutuaide;
            },
            isSarrutAdmin() {
              return this.$store.getters.isSarrutAdmin;
            },
            isSagaAdmin() {
              return this.$store.getters.isSagaAdmin;
            },
            getCommissions() {
                let mutuaide_param;
              let mechanic_id;
                this.isBusy = true;
                let url = 'commissions';
                if (this.isMutuaide()) {
                  mutuaide_param = 1;
                  mechanic_id = this.mechanic_id;
                }
                else {
                  mutuaide_param = 0;
                  if (this.isSarrutAdmin() || this.isSagaAdmin()) {
                    if (this.isSarrutAdmin()) {
                      mechanic_id = 4857;
                    }
                    else if (this.isSagaAdmin()) {
                      mechanic_id = 4870;
                    }
                  } else {
                    mechanic_id = this.mechanic_id;
                  }
                }

                this.apiGet(url, {
                  mutuaide: mutuaide_param,
                  mechanic_id: mechanic_id,
                  ...this.parseFilter()
                })
                    .then(res => {
                      this.isBusy = false;
                      this.commissions = res.data;
                    })
                    .catch(err => {
                      this.isBusy = false;
                      this.showErrorNotification(err);
                    })
                    .finally(() => this.isBusy = false)
            },
            parseDate(date) {
                return this.moment(date).format('DD/MM/YYYY');
            },
            parseAmount(commission) {
              if (this.isDealer()) {
                let amount = 0;
                if (commission && commission.quotes && commission.quotes.length > 0) {
                  for (let i in commission.quotes) {
                    amount += commission.quotes[i].price;
                    amount += commission.quotes[i].assistance_price || 0;
                  }
                }
                return `${parseFloat(amount).toFixed(2)} €`;
              }
              return `${parseFloat(invoiccommission.amount).toFixed(2)} €`;
            },
            parseNum(commission) {
              if (!commission.commission_number.indexOf('A'))
                return 'Avoir '+ commission.commission_number;
              else if (!commission.commission_number.indexOf('I'))
                return 'Facture '+ commission.commission_number;
            },
            getTypeCommmission(commission) {
              if (!commission.commission_number.indexOf('A'))
                return 'Avoir';
              else
                return 'Commission';
            },
            show_pdf(id) {
                this.refreshTokenForce()
                    .then(() => window.location = this.getApiAuthUrl(`commissions/pdf/${id}`))
                    .catch(error => this.showErrorNotification(error));
            },
            show_credit(id) {
              this.refreshTokenForce()
                .then(() => window.location = this.getApiAuthUrl(`commissions/credit-pdf/${id}`))
                .catch(error => this.showErrorNotification(error));
            },
            parseFilter() {
                let data = {}
                if (this.filters.start_date) {
                    data.start_date = this.filters.start_date;
                    data.start_date.setHours(0, 0, 0, 0);
                }
                if (this.filters.end_date) {
                    data.end_date = this.filters.end_date;
                    data.end_date.setHours(23, 59, 59, 0);
                }
                if (this.filters.amount) data.amount = this.filters.amount;

                return data;
            }
        },
        mounted() {
            this.getCommissions();
            this.$eventBus.$on('get-commissions', this.getCommissions);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Commissions/Commissions.vue